export default "__VITE_ASSET__DlorUXDS__"